import { ScorecardDataItem, ExtendedScorecardDataItem } from "api";

/**
 * Processes scorecard data to include cost rows when includeCostData is true
 * @param data - Array of ScorecardDataItem objects
 * @returns Array of ExtendedScorecardDataItem objects with cost rows included
 */
export const processScorecardData = (data: ScorecardDataItem[]): ExtendedScorecardDataItem[] => {
    const result: ExtendedScorecardDataItem[] = [];

    data.forEach((item) => {
        // Add the original row
        result.push(item);

        // Add cost row if includeCostData is true and costValues exist
        if (item.includeCostData && item.costValues && item.costValues.length > 0) {
            const costRow: ExtendedScorecardDataItem = {
                ...item,
                rowId: item.rowId,
                categoryName: item.categoryName,
                kpiName: `${item.kpiName} - Cost`,
                values: item.costValues,
                isCostRow: true,
            };
            result.push(costRow);
        }
    });

    return result;
};
